import { Box, Card, Divider, Skeleton, Stack, Typography } from '@mui/material'
import { blue, grey } from '@mui/material/colors'
import { useEffect, useState } from 'react'
import { Doughnut, Line } from 'react-chartjs-2'


const data = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    datasets: [{
        label: '# of Votes',
        data: [12, 19, 3, 5, 2, 3, 12, 19, 8, 5, 12, 9],
        backgroundColor: [
            'rgba(186, 255, 41, 0.2)',
        ],
        borderColor: [
            '#baff29',
        ],
        borderWidth: 2,
        tension: 0.4,
        fill: true,
        pointBackgroundColor: "#baff29"
    }],
}
const dataSmall = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    datasets: [{
        label: '# of Votes',
        data: [12, 19, 3, 5, 2, 3, 12, 19, 8, 5, 12, 9],
        backgroundColor: [
            'rgba(255, 255, 255, 0.1)',
        ],
        borderColor: [
            blue[400]
        ],
        borderWidth: 1,
        fill: true,
        pointBackgroundColor: "#baff29"
    }],
}

const smallLinConfig = {
    scales:{
        x:{
            ticks: {
                display: false
            },
            grid: {
                display: false
            }
        },
        y:{
            ticks: {
                display: false
            },
            grid: {
                display: false
            }
        }
    },
    plugins: {
        legend: {
            display: false
        }
    },
    elements:{
        point:{
            radius: 0
        }
    }
}

const doughnutData = {
    labels: ['Voltic Water', 'Storm energy', "Ideal milk"],
    datasets: [{
        label: '# of Votes',
        data: [400, 310, 120],
        backgroundColor: [
            'rgba(0, 255, 0, 0.5)',
            'rgba(0, 255, 255, 0.5)',
            'rgba(255, 0, 255, 0.5)',
        ],
        borderColor: [
            blue[400],
            'rgba(255, 255, 255, 0.5)'
        ],
        borderWidth: 0,
        weight: 0.5
    }],
}

const impressData = {
    labels: ['Restock', 'Electricity', 'Waste'],
    datasets: [{
        label: '# of Votes',
        data: [300, 120, 80],
        backgroundColor: [
            'rgba(255, 5, 5, 0.7)',
            'rgba(50, 150, 150, 0.7)',
            'rgba(5, 255, 5, 0.7)',
        ],
        borderColor: [
            blue[400],
            'rgba(255, 255, 255, 0.5)'
        ],
        borderWidth: 0,
        weight: 0.5
    }],
}

export default function ContentBody() {

    const [isLoading, setIsLoading] = useState(false)

    useEffect(()=>{

        setIsLoading(true)

        const timeOut = setTimeout(()=>setIsLoading(false),3000)
        
        return ()=>clearTimeout(timeOut)
        
    },[])
    
    return (
        <>

            {
                isLoading ? (
                    <CustomSkeleton />
                ):(
                    <Stack direction="row" spacing={2}>

                        <Card variant="outlined" sx={styles.cardMax1} >
                            <Typography marginBottom="1rem" >{`Sales History (Annual)`}</Typography>

                            <Stack direction="row" sx={{height:"100%"}} spacing={1} >

                                <Box sx={{flex: 1, height: "100%"}} >
                                    <Line
                                        
                                        options={{ 
                                            maintainAspectRatio: false,
                                            // animation: true,
                                            borderColor: '#baff29',
                                            line: {
                                                datasets: {tension: 0.4}
                                            },
                                            plugins: {
                                                legend: {
                                                    display: false
                                                }
                                            },
                                            scales:{
                                                x: {
                                                    grid: {
                                                    color: 'rgba(255, 255, 255, 0.05)',
                                                    borderColor: 'rgba(255, 255, 255, 0.05)',
                                                    borderDash: [5, 2],
                                                    tickColor: "transparent"
                                                    }
                                                },
                                                y: {
                                                    grid: {
                                                        color: 'rgba(255, 255, 255, 0.05)',
                                                        borderColor: 'rgba(255, 255, 255, 0.05)',
                                                        tickColor: "transparent",
                                                        borderDash: [5, 2]
                                                    }
                                                },
                                            }
                                        }} 
                                        redraw={true} 
                                        data={data} 
                                    />
                                </Box>

                                <Stack divider={<Divider orientation="vertical" sx={{backgroundColor: 'rgba(255, 255, 255, 0.1)'}} />} sx={{flex: 1}} direction="row" spacing={1} >
                                        
                                    <Stack sx={{flex: 1}} spacing={1} justifyContent="space-evenly" direction="column" alignItems="center" >

                                        <Typography color={grey[500]} fontSize={14} fontWeight="light" textAlign="center" >Most valuable products</Typography>

                                        <Typography textAlign="center" >

                                            <Typography variant="h5">
                                                GH₵ 41,200
                                            </Typography>

                                            <Typography color={grey[500]} fontSize={14} >
                                                You gained most of your money from selling Voltic water, Storm energy and Ideal milk.
                                            </Typography>

                                        </Typography>

                                        <Box
                                            sx={{
                                                width: "70px",
                                                height: "70px"
                                            }}
                                        >
                                            <Doughnut
                                                data={doughnutData}
                                                options={{
                                                    maintainAspectRatio: false,
                                                    plugins: {
                                                        legend: {
                                                            display: false
                                                        }
                                                    },
                                                    cutout: "80%"
                                                }}
                                            />
                                        </Box>

                                        
                                    </Stack>

                                    <Stack sx={{flex: 1}} spacing={1} justifyContent="space-evenly" direction="column" alignItems="center" >

                                        <Typography color={grey[500]} fontSize={14} fontWeight="light" textAlign="center" >Top three demanding expenses</Typography>

                                        <Typography textAlign="center" >

                                            <Typography variant="h5">
                                                GH₵ 1,200
                                            </Typography>

                                            <Typography color={grey[500]} fontSize={14} >
                                                Most of your expenses were on Restocking, Electricity and Waste Management.
                                            </Typography>

                                        </Typography>

                                        <Box
                                            sx={{
                                                width: "70px",
                                                height: "70px"
                                            }}
                                        >
                                            <Doughnut
                                                data={impressData}
                                                options={{
                                                    maintainAspectRatio: false,
                                                    plugins: {
                                                        legend: {
                                                            display: false
                                                        }
                                                    },
                                                    cutout: "80%"
                                                }}
                                            />
                                        </Box>

                                        
                                    </Stack>

                                </Stack>

                            </Stack>

                        </Card>

                        <Card variant="outlined" sx={styles.cardMax2}>
                            <Typography marginBottom="2rem" >Business Summary</Typography>

                            <Stack direction="column" spacing={3} flex={1} justifyContent="space-between" >

                                <Stack direction="row">

                                    <Box
                                        sx={{flex: 1, width: "50%"}}
                                    >
                                        <Typography textAlign="left" >

                                            <Typography color={grey[500]} fontSize={14} fontWeight="light" >
                                                Money in shops
                                            </Typography>

                                            <Typography>
                                                GHc 1,152
                                            </Typography>

                                        </Typography>
                                    </Box>

                                    <Box
                                        sx={{flex: 1, width: "50%"}}
                                    >
                                        <Line 
                                            data={dataSmall} 
                                            options={smallLinConfig}
                                        />

                                    </Box>

                                </Stack>

                                <Divider sx={{backgroundColor: 'rgba(255, 255, 255, 0.1)'}} />
                                
                                <Stack direction="row">

                                    <Box
                                        sx={{flex: 1, width: "50%"}}
                                    >
                                        <Typography textAlign="left" >

                                            <Typography color={grey[500]} fontSize={14} fontWeight="light" >
                                                Money in shops
                                            </Typography>

                                            <Typography>
                                                GHc 1,152
                                            </Typography>

                                            </Typography>
                                    </Box>

                                    <Box
                                        sx={{flex: 1, width: "50%"}}
                                    >
                                        <Line 
                                            data={dataSmall} 
                                            options={smallLinConfig}
                                        />

                                    </Box>

                                </Stack>

                                <Divider sx={{backgroundColor: 'rgba(255, 255, 255, 0.1)'}} />

                                <Stack direction="row">

                                    <Box
                                        sx={{flex: 1, width: "50%"}}
                                    >
                                        <Typography textAlign="left" >

                                            <Typography color={grey[500]} fontSize={14} fontWeight="light" >
                                                Money in shops
                                            </Typography>

                                            <Typography>
                                                GHc 1,152
                                            </Typography>

                                            </Typography>
                                    </Box>

                                    <Box
                                        sx={{flex: 1, width: "50%"}}
                                    >
                                        <Line 
                                            data={dataSmall} 
                                            options={smallLinConfig}
                                        />

                                    </Box>

                                </Stack>

                            </Stack>

                        </Card>

                    </Stack>
                )
            }
            
        </>
        
    )
}


const CustomSkeleton = ()=>{

    return(

        <Stack direction="row" spacing={2}>

            <Skeleton variant="rectangular" sx={styles.cardMax1} animation="pulse" />
            <Skeleton variant="rectangular" sx={styles.cardMax2} animation="pulse" />

        </Stack>
        
    )
    
}

const styles={

    cardMax1: {
        flex: 3.35, 
        border: `.5px solid rgba(255, 255, 255, 0.1)`,
        borderRadius: "4px", 
        height: "420px", 
        backgroundColor: "primary.main",
        padding: "1rem",
        paddingBottom: "4rem",
        boxSizing: "border-box"
    },
    cardMax2: {
        flex: 1, 
        border: `.5px solid rgba(255, 255, 255, 0.1)`,
        borderRadius: "4px", 
        height: "420px", 
        backgroundColor: "primary.main",
        padding: "1rem",
        paddingBottom: "4rem",
        boxSizing: "border-box"
    }

}